const PARAGRAPH_TYPE = "ssml-paragraph";
const PARAGRAPH_MARK = "ssml-paragraph";
const PARAGRAPH_HTML_NODE_NAME = "p";
const PARAGRAPH_RENDERED_NODE_NAME = "p";

export { PARAGRAPH_HTML_NODE_NAME, PARAGRAPH_MARK, PARAGRAPH_RENDERED_NODE_NAME, PARAGRAPH_TYPE };
//# sourceMappingURL=constant.js.map
